module.exports = __webpack_public_path__ + "img/Right.ad5a57d6.jpg";